import { useState, useEffect, useCallback } from "react"
import { fetchTasksForParent } from "../api/tasksApi"

// Used on detail pages: tasks scoped to a lead/deal/booking
export function useTasks({ parentType, parentId }) {
  const [tasks, setTasks] = useState(null)
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    if (!parentId) return
    setLoading(true)
    try {
      const data = await fetchTasksForParent(parentType, parentId)
      setTasks(data)
    } catch {
      setTasks([])
    } finally {
      setLoading(false)
    }
  }, [parentType, parentId])

  useEffect(() => { load() }, [load])

  return { tasks, loading, refresh: load, setTasks }
}
